
export const sidebarUser = {
  'backoffice.sidebarUser.sections.dashboard.title': 'Dashboard',
  'backoffice.sidebarUser.sections.dashboard.items.summary': 'Summary',
  'backoffice.sidebarUser.sections.myCommunity.title': 'My Community',
  'backoffice.sidebarUser.sections.myCommunity.items.genealogyTree': 'Genealogy Tree',
  'backoffice.sidebarUser.sections.myCommunity.items.communityMembers': 'Community Members',
  'backoffice.sidebarUser.sections.investmentAccounts.title': 'Investment Accounts',
  'backoffice.sidebarUser.sections.investmentAccounts.items.myAccounts': 'My Accounts',
  'backoffice.sidebarUser.sections.investmentAccounts.items.addAccount': 'Add Account',
  'backoffice.sidebarUser.sections.myProfits.title': 'My Profits',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitSummary': 'Accounts Profit Summary',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitHistory': 'Accounts Profit History',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsSummary': 'Commissions Summary',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsHistory': 'Commissions History',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsPaymentHistory': 'Commissions Payment History',
  'backoffice.sidebarUser.sections.myProfits.items.myPaymentMethods': 'My Payment Methods',
  'backoffice.sidebarUser.sections.startInvesting.title': 'Start Investing',
  'backoffice.sidebarUser.sections.startInvesting.items.createRadexAccount': 'Create Radex Markets Account',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammInstitutional': 'Join PAMM Institutional Trading',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammSpartanAi': 'Join PAMM Spartan AI',
  'backoffice.sidebarUser.sections.startInvesting.items.accessPammAccount': 'Access your PAMM Account',
  'backoffice.sidebarUser.sections.tutorials.title': 'Tutorials',
  'backoffice.sidebarUser.sections.myProfile.title': 'My Profile',
  'backoffice.sidebarUser.sections.myProfile.items.theClubUserProfile': 'The Club User Profile',
  'backoffice.sidebarUser.sections.myProfile.items.personalInformation': 'My Personal Information',
  'backoffice.sidebarUser.sections.myProfile.items.paymentMethods': 'My Payment Methods',
  'backoffice.sidebarUser.sections.myProfile.items.referralLink': 'My Referral Link',
  'backoffice.sidebarUser.sections.support.title': 'Support',
  'backoffice.sidebarUser.sections.support.items.helpCenter': 'Help Center',
  'backoffice.sidebarUser.signOut': 'Sign Out'
};
